// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3dcDO","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2e5Ps"};